import React, { useState } from "react";
import _ from "lodash";
import { ReactComponent as CrossSvg } from "../../../assets/images/opt/cross.svg";
import { ReactComponent as DownArrowSvg } from "../../../assets/images/opt/down-arrow.svg";
import { ReactComponent as DummyAvatarSvg } from "../../../assets/images/opt/dummy-avatar.svg";
import { ReactComponent as CheckBoxEnabledSvg } from "../../../assets/images/opt/checkbox-enabled.svg";
import { ReactComponent as CheckBoxDisabledSvg } from "../../../assets/images/opt/checkbox-disabled.svg";

const AddTeammateModal = ({
  onSave,
  onClose,
  teamMembers,
  setTeamMembers,
  add_teammate_params,
}) => {
  const primary = _.get(add_teammate_params, "primary", "Add Teammate(s)");
  const secondary = _.get(
    add_teammate_params,
    "secondary",
    "Add Teammate(s) to this event by selecting them below"
  );
  const input = _.get(add_teammate_params, "input", "Select Teammates");
  const cancel_btn = _.get(add_teammate_params, "cancel_btn", "Cancel");
  const save_btn = _.get(add_teammate_params, "save_btn", "Save");

  const [dropdownExpanded, setDropdownExpanded] = useState(false);

  const handleUserClick = (user) => {
    const array = teamMembers.map((item) =>
      item.Username === user.Username
        ? { ...item, selected: !item.selected }
        : item
    );
    setTeamMembers(array);
  };

  const handleDropDownText = () => {
    if (teamMembers.some((item) => item.selected)) {
      let array = teamMembers.filter((item) => item.selected);
      if (array.length === 1) {
        return `${array[0].name.trim()}`;
      } else if (array.length === 2) {
        return `${array[0].name.trim()}, ${array[1].name.trim()}`;
      } else {
        return `${array[0].name.trim()}, ${array[1].name.trim()}, +${
          array.length - 2
        } More`;
      }
    } else {
      return input;
    }
  };

  return (
    <div onClick={onClose} className="add-teammate-modal">
      <div onClick={(e) => e.stopPropagation()} className="modal-inner">
        <div className="top-div">
          <h2 className="modal-text">{primary}</h2>
          <CrossSvg onClick={onClose} className="modal-cross" />
        </div>
        <h3 className="secondary-text">{secondary}</h3>
        <div
          className="teammate-dropdown"
          onClick={() => setDropdownExpanded((prev) => !prev)}
        >
          <span className="label">{handleDropDownText()}</span>
          <DownArrowSvg className="dropdown-arrow" />
          {dropdownExpanded && (
            <div onClick={(e) => e.stopPropagation()} className="dropdown-main">
              {teamMembers.map((user, index) => (
                <div
                  className="dropdown-item"
                  key={index}
                  onClick={() => handleUserClick(user)}
                >
                  {user.selected ? (
                    <CheckBoxEnabledSvg className="checkbox" />
                  ) : (
                    <CheckBoxDisabledSvg className="checkbox" />
                  )}
                  {user.picture ? (
                    <img alt="" src={user.picture} className="avatar" />
                  ) : (
                    <DummyAvatarSvg className="avatar" />
                  )}
                  <h2>{user.name}</h2>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="button-div">
          <div onClick={onClose} className="modal-button cancel">
            {cancel_btn}
          </div>
          <div
            onClick={onSave}
            className={`modal-button save ${
              teamMembers.some((item) => item.selected) ? "" : "empty"
            }`}
          >
            {save_btn}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTeammateModal;
